import React, {Component} from 'react';
import Button from './common/Button';
import styled from 'styled-components';
import {numbersPerMonth} from '../data/production';
import RangeSlider from './common/RangeSlider';

const StatWrapper = styled.div`
	text-align: center;
	margin: auto;
`;

const StatNumber = styled.h1`
	color: #669d9e;
	margin: 40px 0 20px;
	font-size: 68px;

	@media screen and (min-width: 768px) {
		font-size: 140px;
		margin: 40px 0;
	}
`;

const MonthLabel = styled.h3`
	color: #669d9e;
`;

const StatHeading = styled.h5`
	margin-bottom: 5px;

	.for-desktop {
		display: none;
	}

	@media screen and (min-width: 768px) {
		margin-bottom: 20px;
		.for-desktop {
			display: block;
		}
	}
`;

class StatisticsSlider extends Component {
	state = {
		currentMonth: 7,
		currentTotal: 0,
		label: 'June',
	};

	componentDidMount() {
		this.setState({
			currentTotal: numbersPerMonth[this.state.currentMonth].production,
			label: numbersPerMonth[this.state.currentMonth].month,
		});
	}

	handleChange = (e) => {
		this.setState({
			currentMonth: e.target.value,
			currentTotal: numbersPerMonth[e.target.value].production,
			label: numbersPerMonth[e.target.value].month,
		});
	};

	render() {
		const {currentMonth, currentTotal, label} = this.state;
		return (
			<section id="production-summary">
				<div className="container container--sm">
					<StatWrapper>
						<StatHeading>
							Over a period of 8 months, we produced and <br className="for-desktop" /> distributed PPE items across
							the country.
						</StatHeading>
						<small>Scroll the slider to see how we did each month.</small>
						<div>
							<StatNumber>{currentTotal.toLocaleString()}</StatNumber>
							<MonthLabel>in {label}</MonthLabel>
						</div>
						<RangeSlider value={currentMonth} label={label} handleChange={this.handleChange} />
						<Button text="Our impact story" anchor="/impact" />
					</StatWrapper>
				</div>
			</section>
		);
	}
}

export default StatisticsSlider;
